/**
 * NewsTabs
 */
class NewsTabs {
  constructor() {

    this.init()
  }

  init() {
    //  create menu html at mobile device
    this._listHtml()
    this._createHtml()
    this._postSlick()
    // this._listTabs()

  }

  _listHtml() {
    $(window).resize(()=> {
      if(window.innerWidth > 1023) {
        $('.home-middle2 .month').map( (k,i)=>{
          // console.log(k, i);
          let num = i.dataset.num;
          let key = `.home-middle2 .month[data-num="${num}"]`
          // console.log($(key));
          // if (window.innerWidth < 1024) return;
          this._createHtml(key)
          
        } )
      }
    }).trigger('resize')
  }

  /**
   * create menu html at mobile device
   */
  _createHtml(key) {
    let parWrapThums = $(`${key} .image`)
    // console.log(parWrapThums);
    
    let thums = $(`${key} .thums`)
    $(thums).html(parWrapThums)

    const newsTabFn = (oList, oThums) => {
      let aElem = oList.children()

      $(oThums).hide().eq(0).show()
      $(aElem).eq(0).addClass('active')

      $(aElem).map((k, v) => {
        
        $(v).on('mouseenter', () => {
          $(aElem).removeClass().eq(k).addClass('active')
          $(oThums).hide().eq(k).show()
        })
      })

    }
    newsTabFn($(`${key} .news-list`), $(`${key} .thums .image`))


  }

  /**
   * create menu html at mobile device
   */
  _postSlick() {
    let more = $('.home-bottom .more-from-category')
    
    $(window).resize(()=> {
      if( !$('.js-posts-slick').hasClass('slick-slider') && window.innerWidth > 1023) {
        $('.js-posts-slick').slick({
          infinite: false,
          responsive:[
            {
              breakpoint: 1023,
              settings: "unslick"
            }
          ]
        })
      }
    }).trigger('resize')

  $('.js-posts-slick').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    if( !$('.slick-next').hasClass('slick-disabled')) {
      // console.log(slick.nextArrow);
      $('.slick-next').html(more.html())

    }
  });

    // $('.slick-next').has('slick-disabled')
  }

  _listTabs() {
    (function($){
      $.fn.hoverDelay = function(options){
          var defaults = {
              hoverDuring: 200,
              outDuring: 200,
              hoverEvent: function(){
                  $.noop();
              },
              outEvent: function(){
                  $.noop();    
              }
          };
          var sets = $.extend(defaults,options || {});
          var hoverTimer, outTimer;
          return $(this).each(function(){
              $(this).hover(function(){
                  clearTimeout(outTimer);
                  hoverTimer = setTimeout(sets.hoverEvent, sets.hoverDuring);
              },function(){
                  clearTimeout(hoverTimer);
                  outTimer = setTimeout(sets.outEvent, sets.outDuring);
              });    
          });
      }      
  })(jQuery);

    $(".news-list .entry").each(function(){
      var that = $(this);
      var id = that.attr("id");
      if(id){
          that.hoverDelay({
              hoverEvent: function(){
                  $(".s1").attr("class","s2");
                  that.attr("class","s1"); 
                  $(this).attr("class","s1"); 
              }        
          });
      }else{
          that.hoverDelay({
              outDuring: 1000,
              hoverEvent: function(){
                  $("#tm").show();        
              },
              outEvent: function(){
                  $("#tm").hide();
              }
          });
      }
  });
  }

}

export default NewsTabs
